var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { withTranslation } from 'react-i18next';
import PhotoUploader from './PhotoUploader';
var CarouselUploadPlaceholder = /** @class */ (function (_super) {
    __extends(CarouselUploadPlaceholder, _super);
    function CarouselUploadPlaceholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarouselUploadPlaceholder.prototype.render = function () {
        if (!this.props.cartItem) {
            return null;
        }
        return (React.createElement(PhotoUploader, { cartItemId: this.props.cartItem.id },
            React.createElement("div", { className: "c-order-photo c-order-photo--placeholder" },
                React.createElement("label", null,
                    React.createElement("div", null,
                        React.createElement("i", { className: "icon-add" })),
                    React.createElement("span", null, this.props.t(this.props.photosCount > 0 ? 'order.products.upload.title' : 'order.products.upload_empty.title'))))));
    };
    return CarouselUploadPlaceholder;
}(React.Component));
export default withTranslation()(CarouselUploadPlaceholder);
